export namespace TestAnalysisActions {
  export class SetAllTestAnalysis {
    static readonly type = '[TestAnalysis] SetAllTestAnalysis';
    constructor(public company: string) {}
  }
  export class SetOrgGroupTestAnalysis {
    static readonly type = '[TestAnalysis] SetOrgGroupTestAnalysis';
    constructor(public orgGroupId: string) {}
  }
export class SetAllTestAnalysisPaginated {
    static readonly type = '[TestAnalysis] SetAllTestAnalysisPaginated';
    constructor(public company: string) {}
  }
  export class SetOrgGroupTestAnalysisPaginated {
    static readonly type = '[TestAnalysis] SetOrgGroupTestAnalysisPaginated';
    constructor(public orgGroupId: string) {}
  }

  export class SetMyTestAnalysis {
    static readonly type = '[TestAnalysis] SetMyTestAnalysis';
    constructor(public userId: string) {}
  }

  export class SetFunctionalGroupTestAnalysis {
    static readonly type = '[TestAnalysis] SetFunctionalGroupTestAnalysis';
    constructor(public functionalGroupIds: string[]) {}
  }

  export class DeleteTestAnalysis {
    static readonly type = '[TestAnalysis] DeleteTestAnalysis';
    constructor(public testAnalysisUid: string, public regBy: string) {}
  }

  export class UpdateItem {
    static readonly type = '[TestAnalysis] UpdateItem';
    constructor(public item: any) {}
  }

  export class ClearCache {
    static readonly type = '[TestAnalysis] ClearCache';
    constructor() {}
  }
}
